export enum FieldVisibility {
    Enabled, Disabled, Hidden
}

export interface CustomerFieldVisibility {
    recID: FieldVisibility;
    firstName: FieldVisibility;
    lastName: FieldVisibility;
    address1: FieldVisibility;
    address2: FieldVisibility;
    city: FieldVisibility;
    state: FieldVisibility;
    zip: FieldVisibility;
    phoneNumber: FieldVisibility;
    emailAddress: FieldVisibility;
}
